import React from "react";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/rounded-left.svg";

export function BackButton({ onClick, className, text }: { onClick?: () => void, className?: string, text?: string }) {
  const handleBack = () => {
    if (onClick) {
      onClick();
    } else {
      window.history.back();
    }
  };
  return (
    <button data-testid="back-button" onClick={handleBack} className={`flex items-center ${className || ""}`}>
      <ArrowLeftIcon />
      {!!text && <span className="text-black text-base">{text}</span>}
    </button>
  );
}
